
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';




export const custom: Routes = [

  { path: '', children: [
    {
      path: '',
      loadChildren: () => import('../../../app/components/dashbord/custom.routes').then(r => r.customRoutingModule)
    },
]
}
]